<template>
  <div :class="componentClassName">
    <div v-if="!isOpened" class="o-phone-dial-window__opener">
      <a-button
        id="phone-dial-window-button"
        variant="icon"
        icon="numpad"
        icon-color="white"
        color="primary-green"
        size="large"
        :float="true"
        @click="handleOpen"
      />
    </div>
    <div v-else class="o-phone-dial-window__body">
      <div class="o-phone-dial-window__indicator">
        <a-icon icon="numpad" color="white" />
      </div>
      <div class="o-phone-dial-window__close">
        <a-button variant="icon" icon="close" icon-color="orange" @click="handleClose" />
      </div>
      <o-phone-dial
        :enable-keyboard="enableKeyboard"
        :available-numbers="availableNumbers"
        :selected-number="selectedNumber"
        :input-number="inputNumber"
        @call="handleCall"
        @update:current-number="handleNumberChange"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';
import OPhoneDial from '@/components/organisms/phone-dial';

export default {
  name: 'o-phone-dial-window',
  components: {
    AButton,
    AIcon,
    OPhoneDial,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    opened: {
      type: Boolean,
      default: null,
    },
    enableKeyboard: {
      type: Boolean,
      default: false,
    },
    availableNumbers: {
      type: Array,
      default: null,
    },
    selectedNumber: {
      type: String,
      default: '',
    },
    inputNumber: {
      type: String,
      default: '',
    },
  },
  emits: ['call', 'update:currentNumber', 'close', 'open'],
  data() {
    return {
      isOpened: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-phone-dial-window', this.isOpened ? 'opened' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    open(val, oldVal) {
      this.isOpened = val;
    },
  },
  mounted() {
    if (this.opened) {
      this.isOpened = this.opened;
    }
  },
  methods: {
    handleCall(value) {
      this.$emit('call', value);
    },
    handleNumberChange(value) {
      this.$emit('update:currentNumber', value);
    },
    handleClose(e) {
      this.isOpened = false;
      this.$emit('close', e);
    },
    handleOpen(e) {
      this.isOpened = true;
      this.$emit('open', e);
    },
  },
};
</script>
